import Modal from "components/Modal/Modal";
import { useSelector } from "react-redux";
import {
  deleteCarnet,
  selectCarnetForDeletion,
  selectState,
  setDeleteCarnetModalOpen,
} from "../carnets.slice";
import { useAppDispatch } from "hooks/hooks";
import { FormatDate } from "utils/dateUtils";
import { toast } from "react-toastify";

const DeleteCarnetModal = () => {
  const {
    deleteCarnetModalOpen,
    selectedDateFrom,
    selectedDateTo,
    selectedProjectId,
  } = useSelector(selectState);
  const carnet = useSelector(selectCarnetForDeletion);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setDeleteCarnetModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      close();
      await dispatch(
        deleteCarnet({
          carnetId: carnet.carnetId,
          projectId: selectedProjectId,
          dateFrom: selectedDateFrom,
          dateTo: selectedDateTo,
        })
      ).unwrap();
      toast.success("Uspesno obrisan.");
    } catch (response: any) {
      if (response.status === 406) {
        toast.warn("Nije dozvoljeno brisanje karneta više od jednog radnog dana u prošlost. Potreban vam je pun pristup modulu karneti.");
      } else if (response.status === 409) {
        toast.warn("Nije dozvoljeno brisanje karneta koje je uneo drugi korisnik. Potreban vam je pun pristup modulu karneti.");
      } else {
        toast.warn("Nije uspelo brisanje karneta. Obratite se podršci.");
      }
    }
  };

  return (
    <Modal
      onClose={close}
      onClick={doDelete}
      isOpen={deleteCarnetModalOpen}
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledeći karnet:
        <br />
        <br />
        <b>
          {carnet?.employee.employeeName} (
          {carnet?.carnetDate && FormatDate(carnet.carnetDate)}) ?
        </b>
      </p>
    </Modal>
  );
};

export default DeleteCarnetModal;
